var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#0050db",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 26a3.626 3.626 0 01-1.844-.505l-5.306-3.12A3.785 3.785 0 017 19.114v-6.23a3.797 3.797 0 011.85-3.259l5.306-3.12A3.664 3.664 0 0116.008 6c.645 0 1.28.174 1.836.505l5.306 3.121A3.785 3.785 0 0125 12.885v6.23a3.797 3.797 0 01-1.85 3.26l-5.306 3.12c-.56.33-1.196.505-1.844.505zm-3.052-6.429l-.983 1a2.69 2.69 0 001.957.822c1.53-.002 2.772-1.264 2.774-2.823v-.852c.42.247.897.377 1.382.376a2.663 2.663 0 001.965-.812l-.982-1c-.26.266-.614.416-.983.416a1.397 1.397 0 01-1.382-1.407v-4.696h-1.382v7.984c0 .779-.62 1.41-1.385 1.41a1.37 1.37 0 01-.981-.418z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJnt);
export default __webpack_public_path__ + "static/media/jnt.b46767772f56b63cccd60a9c648a1f6e.svg";
export { ForwardRef as ReactComponent };